<fury-page-layout mode="card">
  <fury-page-layout-header>
    <div class="headFlex">
      <fury-breadcrumbs [@fadeInRight]  current="Compare Table Content"></fury-breadcrumbs>
      <button mat-button [routerLink]="['/settings/compare-table/add-table-content']" class="sub-button"><span>Edit Content</span></button>
    </div>
   
  </fury-page-layout-header>
  <fury-page-layout-content [@fadeInUp]>
    <div fxLayout="column" fxLayoutAlign="start center">
      <div [@fadeInUp] class="card">
          <p *ngIf="isLoading">Please wait...</p>
          <div *ngIf="!isLoading">
              <div class="contentprt">
                  <h3>Header Text</h3>
                  <div [innerHTML]="compareTableData?.headerText"></div>
              </div>
              <div class="contentprt">
                  <h3>Right Side TextArea</h3>
                  <div [innerHTML]="compareTableData?.rightSideTextArea"></div>
              </div>
              <div class="contentprt">
                  <h3>Table Header Text</h3>
                  <div [innerHTML]="compareTableData?.tableHeaderText"></div>
              </div>
          </div>
      </div>
    </div>
  </fury-page-layout-content>
</fury-page-layout>



 


